import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

const TikTok = (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.4c-1.3.1-2.5-.3-3.6-1v6.2c0 3.4-2.6 5.5-5.6 5.5C7.7 20 5.5 17.9 5.5 15c0-2.8 2.2-4.9 5-4.9.3 0 .6 0 .9.1v2.6c-.3-.1-.6-.2-.9-.2-1.4 0-2.4 1-2.4 2.4 0 1.4 1 2.4 2.4 2.4 1.5 0 2.5-1.1 2.5-2.8V3h3.5z" />
    </svg>
);

const SOCIAL = [
    { label: "Instagram", href: "https://instagram.com/tony.rays", Icon: Instagram },
    { label: "TikTok", href: "https://tiktok.com/@tony.rays", Icon: TikTok },
    { label: "Facebook", href: "https://facebook.com/tony.rays", Icon: Facebook },
];

export const Footer = () => (
    <footer
        className="border-t border-line bg-paper"
        data-testid="footer"
    >
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8 py-20">
            <div className="grid md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <img loading="lazy" decoding="async"
                        src="/logo-tr-full.png"
                        alt="Tony Rays"
                        className="h-20 w-auto object-contain -ml-1"
                        data-testid="footer-logo"
                    />
                    <p className="mt-6 font-serif italic text-2xl text-ink/80 max-w-sm">
                        Simplicity is freedom.
                    </p>
                    <p className="mt-4 text-sm text-ink/55 max-w-sm leading-relaxed">
                        One decision. Months of simplicity. Twenty premium pairs,
                        ready to replace your entire sock drawer.
                    </p>
                    <div className="mt-8 flex items-center gap-3" data-testid="footer-social">
                        {SOCIAL.map(({ label, href, Icon }) => (
                            <a
                                key={label}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={label}
                                data-testid={`social-${label.toLowerCase()}`}
                                className="w-10 h-10 border border-line flex items-center justify-center text-ink/70 hover:bg-ink hover:text-paper transition-colors duration-300"
                            >
                                <Icon size={18} strokeWidth={1.5} />
                            </a>
                        ))}
                    </div>
                </div>

                <div className="md:col-span-3">
                    <p className="eyebrow text-ink/50 mb-6">Shop</p>
                    <ul className="space-y-3 text-sm text-ink/75">
                        <li><Link to="/men" className="link-underline">Men</Link></li>
                        <li><Link to="/women" className="link-underline">Women</Link></li>
                        <li><Link to="/philosophy" className="link-underline">Our Philosophy</Link></li>
                        <li><Link to="/cart" className="link-underline">Cart</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="eyebrow text-ink/50 mb-6">The Promise</p>
                    <ul className="space-y-3 text-sm text-ink/75">
                        <li>20 premium pairs per box</li>
                        <li>Free shipping · 30-day returns</li>
                        <li>Secure payment</li>
                        <li>Timeless. Permanent. Reorderable.</li>
                    </ul>
                    <p className="eyebrow text-ink/50 mt-10 mb-3">Contact</p>
                    <a
                        href="mailto:contact@tonyrays.com"
                        data-testid="footer-email"
                        className="text-sm text-ink/80 hover:text-ink link-underline"
                    >
                        contact@tonyrays.com
                    </a>
                </div>
            </div>

            <div className="mt-16 pt-8 border-t border-line flex flex-col sm:flex-row justify-between gap-4 text-xs text-ink/45">
                <span>© {new Date().getFullYear()} Tony Rays. All rights reserved.</span>
                <div className="flex flex-wrap items-center gap-x-6 gap-y-2 uppercase tracking-[0.2em]">
                    <Link to="/philosophy#contact-section" className="link-underline">Contact</Link>
                    <Link to="/legal" className="link-underline" data-testid="footer-legal">Legal</Link>
                    <span>Less thinking. More living.</span>
                </div>
            </div>
        </div>
    </footer>
);
